export const MODULE_ID = 'contourCloud';
export const REAUTH_TO_CC_MODAL = `${MODULE_ID}/reauthToCCModal`;
